/**
 * Order type options for filters/APIs that use exportID (type code).
 * Same list and labels as the ERP "Bestelltyp" dropdown (Orders.js orderTypesOptions),
 * with value = exportID used by the backend.
 */
export const ORDER_TYPE_EXPORT_OPTIONS = [
	{ exportID: 20, labelKey: 'options_section.strings.return' },
	{ exportID: 7, labelKey: 'options_section.strings.shift' },
	{ exportID: 100, labelKey: 'options_section.strings.inventory' },
	{ exportID: 6, labelKey: 'options_section.strings.delivery_correction' },
	{ exportID: 2, labelKey: 'options_section.strings.order' },
	{ exportID: 51, labelKey: 'options_section.strings.customer_order' },
	{ exportID: 50, labelKey: 'options_section.strings.pre_order_credit_customer' },
	{ exportID: 96, labelKey: 'options_section.strings.orderType_conversion' },
	{ exportID: 95, labelKey: 'options_section.strings.orderType_loss' }
]

export const getOrderTypeExportOptions = (t) =>
	ORDER_TYPE_EXPORT_OPTIONS.map(({ exportID, labelKey }) => ({
		value: exportID,
		label: t(labelKey)
	}))
